module.exports = __webpack_public_path__ + "media/images/riders/MIRANDA_MILLER-e8c6b2a1cd79bc325351a5a09ddb8bac.png";